"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.captchaContainerSaga = exports.fetchCaptchaProvidersSaga = void 0;
const effects_1 = require("redux-saga/effects");
const api_1 = require("astra-core/api");
const slice_1 = require("./slice");
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* fetchCaptchaProvidersSaga() {
    try {
        const captchaProvidersApi = api_1.ApiManager.getApi(betweb_openapi_axios_1.CaptchaProvidersApi);
        const { data: resData } = yield (0, effects_1.call)([
            captchaProvidersApi,
            captchaProvidersApi.getCaptchaProviders,
        ]);
        yield (0, effects_1.put)(slice_1.captchaContainerActions.fetchCaptchaProvidersSuccess(resData));
    }
    catch (e) {
        console.error('Error occurred while fetching captch providers', e);
    }
}
exports.fetchCaptchaProvidersSaga = fetchCaptchaProvidersSaga;
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function* captchaContainerSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeLatest)(slice_1.captchaContainerActions.fetchCaptchaProviders.type, fetchCaptchaProvidersSaga),
    ]);
}
exports.captchaContainerSaga = captchaContainerSaga;
//# sourceMappingURL=saga.js.map